// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../../reason/clients/components/Labels.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let RentalNeedStatus_rentalNeedV5_graphql = require("../../../__generated__/RentalNeedStatus_rentalNeedV5_graphql.bs.js");

let convertFragment = RentalNeedStatus_rentalNeedV5_graphql.Internal.convertFragment;

function RentalNeedStatus$WithoutErrorBoundary(props) {
  let rentalNeed = RescriptRelay_Fragment.useFragment(RentalNeedStatus_rentalNeedV5_graphql.node, convertFragment, props.rentalNeed);
  let s = rentalNeed.status;
  switch (s.__typename) {
    case "ActiveRentalNeed" :
      return null;
    case "ExpiredRentalNeed" :
      return JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {});
    case "RemovedRentalNeed" :
      return JsxRuntime.jsx(Labels.RemovedLabel.make, {});
    case "RentedRentalNeed" :
      return JsxRuntime.jsx(Labels.PurchasedLabel.make, {});
    case "WithdrawnRentalNeed" :
      return JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected rental need status ` + s._0);
  }
}

function RentalNeedStatus(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "rental need status",
    children: JsxRuntime.jsx(RentalNeedStatus$WithoutErrorBoundary, {
      rentalNeed: props.rentalNeed
    })
  });
}

let make = RentalNeedStatus;

exports.make = make;
/* Labels Not a pure module */
